import {
    RefObject, useEffect, useState,
} from 'react';

function useWidth(ref:RefObject<HTMLDivElement|null>): number {
    const [width, setWidth] = useState<number>(0);
    useEffect(() => {
        const onResize = () => {
            const { current } = ref;
            if (current) {
                setWidth(current.offsetWidth);
            }
        };
        onResize();

        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [ref]);
    return width;
}
export default useWidth;
